<template>
  <div class="global-toast-wrap">
    <transition-group name="toast-fade">
      <div
        v-for="item in toast.state.items"
        :key="item.id"
        class="global-toast-item"
        :class="item.type"
        @click="toast.remove(item.id)"
      >
        <span class="toast-icon">{{ iconOf(item.type) }}</span>
        <span class="toast-text">{{ item.text }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import toast from '../utils/toast'

export default {
  name: 'GlobalToast',
  data() {
    return {
      toast
    }
  },
  methods: {
    iconOf(type) {
      const icons = { success: '✓', error: '✕', warning: '!', info: 'i' }
      return icons[type] || 'i'
    }
  }
}
</script>

<style scoped>
.global-toast-wrap {
  position: fixed;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5000;
  display: grid;
  gap: 10px;
  justify-items: center;
  pointer-events: none;
}

.global-toast-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 220px;
  max-width: min(520px, 90vw);
  padding: 12px 18px;
  border-radius: 10px;
  color: #f5f7ff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  background: rgba(15, 19, 32, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.4);
  pointer-events: auto;
  cursor: pointer;
}

.toast-icon {
  display: grid;
  place-items: center;
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  color: #07101d;
  font-size: 13px;
  font-weight: 900;
}

.global-toast-item.success .toast-icon { background: #3ddc97; }
.global-toast-item.error .toast-icon { background: #ff7a6b; }
.global-toast-item.warning .toast-icon { background: #ffcc66; }
.global-toast-item.info .toast-icon { background: #23d3ee; }

.global-toast-item.success { border-color: rgba(61, 220, 151, 0.5); }
.global-toast-item.error { border-color: rgba(255, 122, 107, 0.55); }
.global-toast-item.warning { border-color: rgba(255, 204, 102, 0.5); }
.global-toast-item.info { border-color: rgba(35, 211, 238, 0.5); }

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.25s ease;
}

.toast-fade-enter-from {
  opacity: 0;
  transform: translateY(-14px);
}

.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
